<template>
  <div>
    <div id="SkyShowFeiShuDocumentView"></div>
  </div>
</template>
<script type="text/babel">
import { getFeiShuDocumentSignature } from '@/api/setting'

export default {
  name: 'SkyShowFeiShuDocumentView',
  components: {},
  props: {
    documentUrl: {
      type: String
    }
  },
  data() {
    return {
      myComponent: null,
      anchorId: null,
      tryCur: 0,
      tryCount: 20,
      tryInterval: null
    }
  },
  created() {
    var currentUrl = window.location.origin
    this.tryCur = 0
    getFeiShuDocumentSignature({ url: currentUrl }).then(res => {
      var data = res.data.content
      window.webComponent
        .config({
          openId: null, // 当前登录用户的open id，要确保与生成 signature 使用的 user_access_token 相对应，使用 app_access_token 时此项不填。注意：仅云文档组件可使用app_access_token
          signature: data.signature, // 签名
          appId: data.appId, // 应用 appId
          timestamp: data.timestamp, // 时间戳（毫秒）
          nonceStr: data.noncestr, // 随机字符串
          url: currentUrl, // 第3步参与加密计算的url
          jsApiList: ['DocsComponent'], // 指定要使用的组件列表，请根据对应组件的开发文档填写。如云文档组件，填写['DocsComponent']
          locale: 'zh-CN' // 指定组件的国际化语言：en-US-英文、zh-CN-中文、ja-JP-日文
        })
        .then(res => {
          this.myComponent = window.webComponent.render(
            'DocsComponent',
            {
              // 初始化配置 建议传入，可避免抖动等问题。必须写在src参数前面
              featureConfig: JSON.stringify({
                HEADER: {
                  enable: false //  隐藏头部
                },
                MODAL: {
                  outerMask: true
                },
                LIKE: {
                  enable: false
                },
                DIRECTORY: {
                  enable: true,
                  pin: true
                },
                CONTENT: {
                  unscrollable: false,
                  readonly: true
                },
                COMMENT: {
                  partial: {
                    enable: false,
                    open: false
                  },
                  global: {
                    enable: false
                  }
                }
              }),
              src: this.documentUrl,
              // minHeight: '500px',
              height: '90vh',
              width: '100%'
            },
            document.querySelector('#SkyShowFeiShuDocumentView') // 将组件挂在到哪个元素上
          )
          this.anchorId = this.documentUrl.match(/#(.*)$/)?.[1] || ''
          if (this.anchorId && this.anchorId !== '') {
            this.tryInterval = setInterval(() => {
              this.invokeWithRetry(this.anchorId)
              this.tryCur++
            }, 3000)
          }
        })
    })
  },
  methods: {
    invokeWithRetry(anchorId) {
      if (this.tryCur >= this.tryCount) clearInterval(this.tryInterval)

      // 调用方法
      this.myComponent.invoke.anchorJump(anchorId, false).then(response => {
        if (response.code === 0) {
          clearInterval(this.tryInterval)
        }
        this.highlightAnchor(anchorId, 0, 3)
      })
    },
    highlightAnchor(anchorId, attempt = 0, maxAttempts = 3) {
      if (attempt >= maxAttempts) return
      setTimeout(() => {
        this.myComponent.invoke.anchorJump(anchorId, false).then(response => {
          this.myComponent.invoke.highlightAnchor(anchorId).then(response => {
            this.highlightAnchor(anchorId, attempt + 1, maxAttempts)
          })
        })
      }, 2000)
    }
  }
}
</script>
